import {Slide, ToastContainer} from 'react-toastify';

import {UserProfileProvider} from './providers/context/UserProfileReadyContext/UserProfileReadyContext';
import NetWorkProvider from './providers/network';
import NotificationProvider from './providers/network/notificationProvider/notificationProvider';
import {RouterProvider, ThemeProvider, URQLProvider} from './providers';

import 'react-toastify/dist/ReactToastify.css';
import './app.css';

const App = () => (
  <URQLProvider>
    <ThemeProvider>
      <NotificationProvider>
        <NetWorkProvider>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition={Slide}
          />
          <UserProfileProvider>
            <RouterProvider />
          </UserProfileProvider>
        </NetWorkProvider>
      </NotificationProvider>
    </ThemeProvider>
  </URQLProvider>
);

export default App;
